import { Component, OnInit } from '@angular/core';
import { QuizService } from './quiz.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
  test: any;
  numOfAnsweredQuestions = 0;
  testSubmited = false;
  numOfCorrectAnswers = 0;
  testActive = false;
  totalPoints = 0;
  timeLeftInterval: any;
  testLength: number;
  constructor(private quiz: QuizService, private firestore: AngularFirestore) {
    this.test = quiz.getSelectedTest();
    this.testLength = (this.test.timeLimit == 0) ? undefined : this.test.timeLimit;
    this.test.questions.forEach((q, i) => {
      q.index = i;
      q.answers.forEach(a => a.selected = false)
      // q.selectedAnswer = q.answers.find(a => a.text === q.selectedAnswer.text);
    })
    delete this.test.instances;
    console.log(this.test)
    if (this.test.submited) {
      this.finishQuiz();
    }
  }

  ngOnInit(): void {
  }
  radioChange(e, q) {
    console.log(e)
    q.answered = true;
    console.log(q)
    q.answers.forEach(a => a.selected = false)
    e.value.selected = true;
    this.numOfAnsweredQuestions = this.test.questions.filter(q => q.answered).length
  }
  startCountdown() {
    this.timeLeftInterval = setInterval(() => {
      if (this.testLength === 0) {
        this.finishQuiz();
        clearInterval(this.timeLeftInterval)
      } else {
        this.testLength -= 1;
      }
    }, 1000 * 60)
  }
  startQuiz() {
    this.testActive = true;
    if (this.testLength) this.startCountdown();
  }
  async finishQuiz() {
    console.log(this.test);
    clearInterval(this.timeLeftInterval)
    let points = 0;
    this.totalPoints = 0;
    this.test.questions.forEach(q => {
      // points += q.answers.filter(a => {
      //   return a.selected && a.correct
      // }).length
      q.points = 0;
      this.totalPoints += q.positivePoints;
      if (q.type === 'singleChoice') {
        q.points = q.answers.reduce((sum, a) => {
          if (!q.resolved) {
            q.resolved = true;
            if (a.neutral && a.selected) {
              console.log("NEUTRAL")
              q.neutral = true;
              return sum;
            } else if (a.selected && a.correct) {
              console.log("CORRECT")
              q.correct = true;
              return sum + parseFloat(q.positivePoints);
            } else if (a.selected && !a.correct) {
              console.log("FALSE")
              q.false = true;
              return sum + parseFloat(q.negativePoints);
            } else if (!a.selected) {
              console.log("OTHER")
              q.notFilled = true;
              q.resolved = false;
              return sum;
            }
          }
          return sum;
        }, 0);
      } else {
        let numOfSelectedNeutral = q.answers.filter(a => a.neutral && (a.selected || a.ngClass.selected)).length;
        let numOfSelectedCorrect = q.answers.filter(a => (a.selected || a.ngClass.selected) && a.correct).length;
        let numOfCorrect = q.answers.filter(a => a.correct).length;
        console.log(numOfSelectedNeutral, numOfSelectedCorrect, numOfCorrect)
        if (numOfSelectedNeutral > 0) {

        } else if (numOfSelectedCorrect === numOfCorrect) {
          q.points = q.positivePoints;
        } else {
          q.points = q.negativePoints;
        }
      }
      if (q.points === 0 && !q.neutral) q.points = -1;
      console.log(q.points, !q.neutral)
      points += q.points;
    })
    this.numOfCorrectAnswers = points;
    this.markAnswers();
    this.testSubmited = true;
    console.log(this.test)
    if (!this.test.submited) {
      this.test.submited = true;
      await this.quiz.getRef().update(this.test);
      await this.quiz.getSubjectRef().update({
        testFinished: true
      })
      alert("Rešenja su dostupna u sekciji PREDMETI")
    }
  }
  answerChange(question) {
    const numOfSelectedAnswers = question.answers.filter(a => a.selected).length
    question.answered = (numOfSelectedAnswers > 0);
    this.numOfAnsweredQuestions = this.test.questions.filter(q => q.answered).length
  }
  scroll(id) {
    console.log(`scrolling to ${id}`);
    let el = document.getElementById(id);
    el.scrollIntoView();
  }
  markAnswers() {
    this.test.questions.forEach((q, i) => {

      q.answers.forEach(a => {
        a.disabled = true;
        a.ngClass = {
          'correctAnswer': (a.correct),
          'wrongAnswer': (a.selected && !a.correct && !a.neutral),
          'neutralAnswer': (a.selected && a.neutral)
        }
      })
    })
  }
}
